import React from "react";
import { AddCircleOutline } from "@material-ui/icons";
import { ManageOfferingsBtn } from "features/ManageOfferings/modules/ManageOfferingsBtn/ManageOfferingsBtn";
import { useFeedbacks } from "ui/pages/ExlyFeedbacks/data/useFeedbacks";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import ReviewForm from "ui/pages/ExlyFeedbacks/components/PublishedFeedbacks/ReviewForm";
import { LazyLoadWrapper } from "features/Common/LazyLoadWrapper/LazyLoadWrapper";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";

export const AddReviewBtn = withComponentLibraryTheme(() => {
  const { handleModalOpen, handleModalSave, show_modal, getReviewModalProps } =
    useFeedbacks();
  return (
    <>
      <ManageOfferingsBtn
        btnText="Add review"
        startIcon={AddCircleOutline}
        action={({ listing_uuid }) =>
          handleModalOpen({ listing__uuid: listing_uuid })
        }
      />
      <LazyLoadWrapper loadingCondition={show_modal}>
        <ExlyModal
          padded={false}
          onPrimaryBtnClick={() => handleModalSave()}
          onSecondaryBtnClick={() => handleModalSave(true)}
          open={show_modal}
          {...getReviewModalProps()}
        >
          <ReviewForm />
        </ExlyModal>
      </LazyLoadWrapper>
    </>
  );
});
